import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { FailedSolutions } from '../components/FailedSolutions';
import { MechanismSection } from '../components/MechanismSection';
import { WhatYouGet } from '../components/WhatYouGet';
import { AudienceSection } from '../components/AudienceSection';
import { HowItWorks } from '../components/HowItWorks';
import { FAQSection } from '../components/FAQSection';
import { OfferBlock } from '../components/OfferBlock';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-[#0B1A2E] text-[#F1F5F9] selection:bg-[#2DD4BF]/30 selection:text-white flex flex-col" data-id="element-154">
      <main className="flex-grow" data-id="element-155">
        <HeroSection data-id="element-156" />
        <ProblemSection data-id="element-157" />
        <FailedSolutions data-id="element-158" />
        <MechanismSection data-id="element-159" />
        <WhatYouGet data-id="element-160" />
        <AudienceSection data-id="element-161" />
        <HowItWorks data-id="element-162" />
        <FAQSection data-id="element-163" />
        <OfferBlock data-id="element-164" />
      </main>
      <Footer data-id="element-165" />
    </div>;
}